import { RoutePath } from '../../components/route/type';

export enum LegalLink {
  AGB = 'AGB',
  Datenschutz = 'Datenschutz',
  Impressum = 'Impressum',
  Sitemap = 'Sitemap',
}

type LegalLinkRecord = Record<
  LegalLink,
  {
    text: string;
    url: string;
  }
>;

export const LEGAL_LINKS: LegalLinkRecord = {
  [LegalLink.AGB]: { text: 'AGB', url: RoutePath.Agb },
  [LegalLink.Datenschutz]: { text: 'Datenschutz', url: RoutePath.Datenschutz },
  [LegalLink.Impressum]: { text: 'Impressum', url: RoutePath.Impressum },
  [LegalLink.Sitemap]: { text: 'Sitemap', url: RoutePath.Sitemap },
};
